import React from "react";
import { Calendar } from "@/components/ui/calendar";

/**
 * BrandedCalendar — a single Calendar look that overrides the default
 * shadcn styles with explicit Thai Gayu colors (dark teal + brass gold).
 *
 * The default shadcn Calendar uses `bg-primary` for the selected day, which
 * resolves to near-invisible on this app's dark theme — users couldn't tell
 * whether their selection had registered. This wrapper makes selected day
 * unmistakable (filled brass tile, dark ink text), and bumps day cell size
 * for finger-friendly mobile tap targets.
 */
export default function BrandedCalendar({ selected, onSelect, ...rest }) {
  return (
    <Calendar
      mode="single"
      selected={selected}
      onSelect={onSelect}
      initialFocus
      data-testid="branded-calendar"
      className="bg-transparent text-[var(--ink)]"
      classNames={{
        months: "flex flex-col space-y-4",
        month: "space-y-3",
        caption: "flex justify-center pt-1 relative items-center text-[var(--ink)]",
        caption_label: "text-sm font-medium tracking-wide",
        nav: "space-x-1 flex items-center",
        nav_button:
          "h-8 w-8 bg-transparent rounded-lg p-0 opacity-80 hover:opacity-100 hover:bg-[rgba(216,185,122,0.12)] transition-colors border border-[rgba(216,185,122,0.25)]",
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse",
        head_row: "flex",
        head_cell:
          "rounded-md w-10 font-mono uppercase tracking-[0.12em] text-[10px] text-[var(--accent-soft)]",
        row: "flex w-full mt-1.5",
        cell: "relative p-0 text-center text-sm focus-within:relative focus-within:z-20",
        day: "h-10 w-10 p-0 font-display text-sm rounded-lg text-[var(--ink)] hover:bg-[rgba(216,185,122,0.10)] transition-colors aria-selected:opacity-100 cursor-pointer",
        day_selected:
          "!bg-[#D8B97A] !text-[#15110D] hover:!bg-[#D8B97A] focus:!bg-[#D8B97A] font-semibold shadow-[0_0_18px_-2px_rgba(216,185,122,0.55)]",
        day_today: "ring-1 ring-[rgba(216,185,122,0.6)] ring-inset",
        day_outside: "text-[var(--ink)]/30",
        day_disabled: "text-[var(--ink)]/20 opacity-50 cursor-not-allowed",
        day_hidden: "invisible",
      }}
      {...rest}
    />
  );
}
